import { create } from 'zustand'

import { INotification } from './types'

interface Store {
    notification: INotification | null
    queue: INotification[]
}

interface Actions {
    enqueueNotification: (notification: INotification) => void
    clearNotification: () => void
}

export const useNotificationStore = create<Store & Actions>((set) => ({
    notification: null,
    queue: [],
    enqueueNotification: (notification: INotification) =>
        set((state) => {
            if (state.notification) {
                return { queue: [...state.queue, notification] }
            }
            return { notification }
        }),
    clearNotification: () =>
        set((state) => {
            const [next, ...rest] = state.queue
            if (next) {
                return { notification: next, queue: rest }
            }
            return { notification: null, queue: [] }
        }),
}))
